"use client";

// Reps : mur d'inscription pour les visiteurs sans compte.
// Modèle Duolingo/Mimo : une leçon découverte offerte, puis création de compte
// obligatoire pour continuer et sauvegarder sa progression. Univers Reps =
// tutoiement (voix BeBot) -> illustration BeBot à l'appui.
// - RepsSignupButtons : la paire de CTA (créer un compte / se connecter),
//   réutilisée dans l'écran de fin de la 1re leçon (le player garde alors ses
//   stats de célébration au-dessus : levier d'aversion à la perte).
// - RepsSignupGate : l'écran plein affiché quand l'essai a déjà été consommé.
// Le CTA "J'ai déjà un compte" transporte le chemin de retour via ?redirect=
// (géré par LoginComponent). L'inscription passe par l'onboarding habituel.

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";

// Les deux CTA, partagés entre l'écran de fin (1re leçon) et le mur plein écran.
// `!text-white` / `hover:text-*` explicites : sans eux, la règle globale
// `a:hover { text-primary-300 }` (styles/globals.css) repeindrait le texte des
// liens en rose au survol.
export function RepsSignupButtons({ loginRedirect }) {
    const t = useTranslations();
    const loginHref = loginRedirect
        ? { pathname: "/login", query: { redirect: loginRedirect } }
        : "/login";
    return (
        <div className="flex w-full max-w-xs flex-col gap-3">
            {/* ?source= : /signup l'écrit dans User.originSource. Sans lui,
                un compte créé depuis le chemin Reps web était indiscernable de
                n'importe quelle inscription du site : Reps web était le seul
                angle mort d'attribution qui ne coûtait qu'un paramètre. */}
            <Link
                href={{ pathname: "/signup", query: { source: "reps-web" } }}
                className="rounded-2xl border-b-4 border-b-orange-700 bg-orange-500 px-5 py-3 text-center text-sm font-bold !text-white transition-all hover:bg-orange-600 hover:!text-white active:translate-y-1 active:border-b-transparent"
            >
                {t("reps_signup_gate_create_account")}
            </Link>
            <Link
                href={loginHref}
                className="rounded-2xl border border-gray-200 bg-white px-5 py-3 text-center text-sm font-bold text-gray-600 transition-colors hover:bg-gray-50 hover:text-gray-800 dark:border-white/15 dark:bg-white/[0.04] dark:text-grayDark-200 dark:hover:bg-white/[0.07] dark:hover:text-white"
            >
                {t("reps_signup_gate_have_account")}
            </Link>
        </div>
    );
}

// Mur plein écran : le visiteur a déjà consommé sa leçon découverte.
export default function RepsSignupGate({ loginRedirect }) {
    const t = useTranslations();
    return (
        <div className="fixed inset-0 z-[60] flex animate-fadeIn flex-col items-center justify-center overflow-hidden bg-[#f5f5fa] px-6 text-center text-gray-900 dark:bg-[#192734] dark:text-white">
            <img
                src="/images/bebot/upgrade/confetti.webp"
                alt="BeBot"
                className="mb-5 h-36 w-36 object-contain"
            />
            <h1 className="mb-2 text-2xl font-bold">
                {t("reps_signup_gate_used_title")}
            </h1>
            <p className="mb-7 max-w-sm text-sm text-gray-500 dark:text-grayDark-400">
                {t("reps_signup_gate_used_message")}
            </p>
            <RepsSignupButtons loginRedirect={loginRedirect} />
            <Link
                href="/reps"
                className="mt-4 text-sm text-gray-400 transition-colors hover:text-gray-600 dark:hover:text-grayDark-300"
            >
                {t("reps_signup_gate_back")}
            </Link>
        </div>
    );
}
